import { Button, Divider, Form, Input, InputNumber, Radio, Typography } from 'antd';
import React, { useEffect } from 'react';
import { TabChatManagementKeys, useOmniHistoriesLeadManageContext } from 'contexts';
import { messages, omniChatMessages } from 'messages';
import OmniChannelSourceSelect from './OmniChannelSourceSelect';
import dayjs from 'dayjs';
import { SelectUsers } from 'components/users';
import { ChatIcon, LoupIcon } from 'assets';
import { DateRangePicker } from 'components/common';

type Props = {};

export enum SearchType {
  CUSTOMER = 0,
  EXTENSION = 1,
  TICKET = 2
}

const OmniChannelLeadChatHistoriesFilterForm: React.FC<Props> = () => {
  const {
    searchChatSessions,
    setChatOngoing,
    setChatHistory,
    tab,
    originalArgsOngoing,
    originalArgsHistories,
    setSearchType,
    isLoadingOngoing,
    isLoadingHistories
  } = useOmniHistoriesLeadManageContext();

  const [form] = Form.useForm();

  const searchTypeFrom = Form.useWatch('searchType', form);
  const source = Form.useWatch('source', form);
  const extensionId = Form.useWatch('extensionId', form);

  useEffect(() => {
    if (tab === TabChatManagementKeys.ONGOING) {
      form.submit();
    }
  }, [extensionId]);

  useEffect(() => {
    form.submit();
  }, [searchTypeFrom]);

  useEffect(() => {
    if (tab === TabChatManagementKeys.ONGOING) {
      form.setFieldsValue({
        extensionId: originalArgsOngoing?.extensionId,
        source: originalArgsOngoing?.source || undefined
      });
    } else {
      form.setFieldsValue({
        customerId: undefined,
        pageId: '',
        extensionId: undefined,
        source: originalArgsHistories?.source,
        time: originalArgsHistories?.fromStartTime
          ? [
              dayjs(originalArgsHistories.fromStartTime),
              originalArgsHistories?.toStartTime ? dayjs(originalArgsHistories.toStartTime) : dayjs()
            ]
          : [dayjs(), dayjs()]
      });
    }
  }, [tab]);

  return (
    <Form
      form={form}
      className='flex-1 px-5 pt-4'
      layout='vertical'
      onFinish={(values) => {
        setChatHistory(undefined);
        setChatOngoing(undefined);
        const [id, pageId] = values?.customerId?.split(':') || [];
        const data =
          tab === TabChatManagementKeys.ONGOING
            ? {
                extensionId: values.extensionId,
                source: values.source
              }
            : {
                fromStartTime: values.time?.[0]?.startOf('day').toISOString(),
                toStartTime: values.time?.[1]?.endOf('day').toISOString(),
                customerId: id,
                pageId,
                source: values.source,
                extensionId: values.extensionId,
                keyword: values.keyword,
                ticketId: values.ticketId
              };
        searchChatSessions(data);
        setSearchType(values.searchType);
      }}
    >
      {tab === TabChatManagementKeys.ONGOING ? (
        <div className='flex gap-2'>
          <Form.Item className='w-[260px]' name='extensionId'>
            <SelectUsers
              allowClear
              valueField='extensionId'
              placeholder={omniChatMessages.extensionNo}
              className='no-transform-select extension-chat'
              renderExtension
            />
          </Form.Item>
          <Form.Item name='source' noStyle />
          <div className='w-40'>
            <OmniChannelSourceSelect
              prefix={<ChatIcon height={16} width={16} />}
              value={source}
              isAll
              placeholder={omniChatMessages.channelChat}
              allItemLabel={messages.all}
              onChange={(val) => {
                form.setFieldValue('source', val);
                form.submit();
              }}
              popupClassName='!px-0 !py-4'
              className='channel-source bg-colorBgItemHover'
            />
          </div>
        </div>
      ) : (
        <>
          <div className='mb-4 flex flex-col gap-4'>
            <div className='flex h-10 w-full items-center'>
              <Form.Item noStyle name='searchType' initialValue={SearchType.CUSTOMER}>
                <Radio.Group className='flex w-full items-center'>
                  <Radio className='flex flex-1' value={SearchType.CUSTOMER}>
                    <Typography.Text>{omniChatMessages.customerNameCompact}</Typography.Text>
                  </Radio>
                  <Radio className='flex flex-1' value={SearchType.EXTENSION}>
                    <Typography.Text>{omniChatMessages.extension}</Typography.Text>
                  </Radio>
                  <Radio className='flex flex-1' value={SearchType.TICKET}>
                    <Typography.Text>{omniChatMessages.ticketId}</Typography.Text>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </div>
          <Form.Item
            noStyle
            shouldUpdate={(prev, curr) => {
              // if (prev.searchType !== curr.searchType) {
              //   form.setFieldsValue({ customerId: undefined });
              //   form.setFieldsValue({ pageId: undefined });
              //   form.setFieldsValue({ extensionId: undefined });
              // }
              return prev.searchType !== curr.searchType;
            }}
          >
            {() => {
              switch (searchTypeFrom) {
                case SearchType.EXTENSION:
                  return (
                    <Form.Item className='mb-6' name='extensionId'>
                      <SelectUsers
                        allowClear
                        className='no-transform-select'
                        valueField='extensionId'
                        placeholder={omniChatMessages.extension}
                        renderExtension
                      />
                    </Form.Item>
                  );
                case SearchType.TICKET:
                  return (
                    <Form.Item className='mb-6' name='ticketId'>
                      <InputNumber
                        className='no-transform-select'
                        placeholder={omniChatMessages.ticketId}
                        style={{ width: '100%' }}
                        controls={false}
                      />
                    </Form.Item>
                  );
                default:
                  return (
                    // <Form.Item className='mb-6' name='customerId'>
                    //   <OmniChannelCustomerSelect
                    //     className='no-transform-select'
                    //     allowClear
                    //     placeholder={omniChatMessages.customerName}
                    //   />
                    // </Form.Item>
                    <Form.Item className='mb-6' name='keyword'>
                      <Input className='no-transform-select' placeholder={omniChatMessages.customerName} />
                    </Form.Item>
                  );
              }
            }}
          </Form.Item>
          <Divider className='mb-5' />
          <Form.Item className='mb-4 bg-white' name='time'>
            <DateRangePicker
              defaultValue={[dayjs(), dayjs()]}
              format={'DD/MM/YYYY'}
              className='w-full'
              placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
            />
          </Form.Item>
          <Form.Item className='mb-10' name='source'>
            <OmniChannelSourceSelect
              prefix={<ChatIcon height={16} width={16} />}
              className='w-full bg-white'
              isAll
              placeholder={omniChatMessages.channelChat}
              allItemLabel={omniChatMessages.allChannelsChat}
            />
          </Form.Item>
          <Form.Item noStyle name='pageId' />
        </>
      )}

      {tab === TabChatManagementKeys.HISTORY && (
        <Button
          loading={isLoadingOngoing || isLoadingHistories}
          type='primary'
          size='large'
          icon={<LoupIcon />}
          className='h-12 w-full'
          htmlType='submit'
        >
          {messages.search}
        </Button>
      )}
    </Form>
  );
};
export default OmniChannelLeadChatHistoriesFilterForm;
